const initialState = {
  mdReachData: [],
};

const mdReachSlice = (set) => ({
  ...initialState,
  setMdReachData: (mdReachData) => set({ mdReachData }),
  resetMdReachData: () => set(initialState),
});

export default mdReachSlice;
